import { connect } from 'react-redux';
import { selectRouteParams } from 'selectors/general';

import { selectRoster } from './PrintRoster.selectors';
import PrintRoster from './PrintRoster';

const mapStateToProps = state => {
  const { scheduleId } = selectRouteParams(state);
  const { isLoading: rosterIsLoading, roster } = selectRoster(state, scheduleId);

  return {
    roster,
    rosterIsLoading,
  };
};

export default connect(mapStateToProps)(PrintRoster);
